import {
  mailOnayStart,
  mailOnaySuccess,
  mailOnayError,
} from "../slices/mailOnaySlice";
import api from "../../utils/apiAuth";
import { updateUserProfile } from "../actions/userActions";

export const sendEmailVerification =
  (email, redirectUrl) => async (dispatch, getState) => {
    try {
      dispatch(mailOnayStart());

      // API isteği
      const response = await api.post("/auth/send-email-confirmation", {
        email: email,
        redirectUrl: redirectUrl,
      });

      dispatch(mailOnaySuccess());
    } catch (error) {
      dispatch(
        mailOnayError(
          error.response?.data?.message || "E-posta onay isteği gönderilemedi."
        )
      );
    }
  };
